import useToggle from '../hooks/useToggle';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {get, post} from '../../../api';
import Skeleton from 'react-loading-skeleton';
import {TickIcon} from '../../../icons/Icons';
import Modal from '../Modal';
import MarkdownLoader from '../../pages/landing/MarkdownLoader';
import FormRenderer from '../formbuilder/FormRenderer';
import {FiDownload} from 'react-icons/fi';
import {FormattedMessage} from 'react-intl';
import SignatureInput from "./SignatureInput";
import FormGroup from "./FormGroup";

export default function ContractInput({contractId,
                                        label,
                                        value, onChange}){
  const [visible, toggle] = useToggle();
  const [contract, setContract] = useState(null)
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [signature, setSignature] = useState();
  const [contractData, setContractData] = useState({})
  // const settings = useSelector((state)=>state.settings);
  // useEffect(() => {
  //   if(contract?.custom_fields){
  //     const obj = {};
  //     contract?.custom_fields.map((i)=>{
  //       obj[i] = settings[i] || undefined
  //     })
  //     setContractData(obj)
  //   }
  // }, [settings, contract?.custom_fields]);
  useEffect(()=>{
    setContractData(value || {})
  },[value])
  //fetch custom html
  useEffect(()=>{
    setLoading(true)
    get('/signup_contract/'+contractId).then((data)=>{
      setContract(data.contract)
      setLoading(false)
    })
  },[contractId])
  const onSubmit = useCallback((e)=>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setSaving(true)
    setError('')
    post('/signup_contract/'+contractId, {
      customData: contractData,
      signature,
      fileName: label || contract?.title,
    }).then((data)=>{
      setSaving(false)
      if(data.error){
        setError(data.error)
      }else {
        toggle()
        onChange({
          target: {
            value: {
              ...contractData,
              ...data,
            }
          }
        })
      }
    })
  },[signature, contractData, onChange])
  const canSubmit = useMemo(()=>{
    if(contract && contractData && contract.custom_fields) {
      for (let {isRequired, id} of contract.custom_fields) {
        if (isRequired && !contractData[id]) {
          return false;
        }
      }
      return true;
    } else return !!signature;
  },[signature, contract, contractData])
  if(loading){
    return <Skeleton height={48.5} />
  }
  return <>
    <div className={'list-group mt-1'}>
      <button onClick={toggle} type={"button"} className="d-flex align-items-center justify-content-between list-group-item list-group-item-action">
        { label || contract?.title || 'Contract not found'}

        {
          contractData.url ? <span className={"text-success"}>
                            <TickIcon />
                    </span>: null
        }
      </button>
    </div>
    {
      contract && contract.url ?
          <Modal confirmLoading={saving} title={label || contract?.title} okText={'Submit'}
                 disabled={!canSubmit}
                 onSubmit={!contractData.url ? onSubmit : null}
                 visible={visible}
                 size={"lg"} onClose={toggle}>
            <div style={{height:400, overflowY: 'scroll', overflowX:'hidden'}} className={"p-3 mb-4 border rounded shadow-sm"}>
              <MarkdownLoader source={contract.url}
                customObject={contractData}
                formFields={contract.custom_fields}
              />
            </div>
            <hr/>
            {
              contractData.url ? <a href={contractData.url} download={`Download.pdf`}><FiDownload /> <FormattedMessage id={"Download"} /></a> :
              contract.custom_fields ?
                  <FormRenderer onChange={setContractData}
                                value={contractData}
                                formFields={contract.custom_fields}/> :
                  <FormGroup label={"Signature"}>
                    <SignatureInput value={signature} onChange={({target})=>setSignature(target.value)} ></SignatureInput>
                  </FormGroup>
            }
            {
              error ? <div className={"alert alert-danger mt-3"}>{error}</div> : null
            }
          </Modal> : null
    }
  </>
}
